<template>
    <section class="main dashboard">

        <div class="filters with-compare">
            <h1>Navigator Reports</h1>
            <div>
                <div class="input-with-control date-control">
                    <label>Start</label>
                    <label>End</label>
                    <label></label>
                    <input class="warehouse" type="date" :min="minFilterDate" :max="maxFilterDate" v-model="filters.start_date" required="required">
                    <input class="warehouse" type="date" :min="minFilterDate" :max="maxFilterDate" v-model="filters.end_date" required="required">
                    <div class="button warehouse input-go" @click="setFilterDates()"><i class="fas fa-calendar-check"></i></div>
                </div>
            </div>
            <div>
                <div class="button warehouse compare-button" @click="showCompare = true"><i class="fas fa-calendar-plus"></i></div>
            </div>
        </div>

        <div v-if="message" class="empty-list">
            {{ message }}
            <div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>
        <div v-else class="two-columns tiles">
            <div class="tile">
                <div class="title inventory">Store Inventory</div>
                <div class="stat" v-html="formatNumber(totals.inventory_onhand_total, true)"></div>
                <div class="caption">Retail value <label>(current onhand)</label></div>
                <router-link :to="{ path: '/inventory', query: $route.query }" class="link inventory"><span class="icon">&#x27A4;</span> Store Inventory Report</router-link>
            </div>
            <div class="tile">
                <div class="title suppliers">Inventory Received</div>
                <div class="stat" v-html="formatNumber(totals.inventory_received_total, true)"></div>
                <div class="caption">Retail value <label>(year to date)</label></div>
                <router-link :to="{ path: '/suppliers', query: $route.query }" class="link suppliers"><span class="icon">&#x27A4;</span> Inventory Received Report</router-link>
            </div>
            <div class="tile">
                <div class="title sales">Store Sales</div>
                <div class="stat" v-html="formatNumber(totals.inventory_sold_total, true)"></div>
                <div class="caption">Retail value <label>(year to date)</label></div>
                <router-link :to="{ path: '/sales', query: $route.query }" class="link sales"><span class="icon">&#x27A4;</span> Store Sales Report</router-link>
            </div>
            <div class="tile">
                <div class="title warehouse">Warehouse Orders</div>
                <div class="stat" v-html="formatNumber(totals.inventory_warehouse_total, true)"></div>
                <div class="caption">Retail value <label>(year to date)</label></div>
                <router-link :to="{ path: '/warehouse', query: $route.query }" class="link warehouse"><span class="icon">&#x27A4;</span> Warehouse Orders Report</router-link>
            </div>
            <div class="tile">
                <div class="title distributors">Distributor Movement</div>
                <div class="stat" v-html="formatNumber(totals.distributor_movement_total, true)"></div>
                <div class="caption">Moved cost <label>(year to date)</label></div>
                <router-link :to="{ path: '/distributors', query: $route.query }" class="link distributors"><span class="icon">&#x27A4;</span> Distributor Movement Report</router-link>
            </div>
            <div class="tile" v-if="showManufacturerTile">
                <div class="title manufacturers">Manufacturer Performance</div>
                <div class="stat">{{ formatNumber(totals.manufacturer_count) }}</div>
                <div class="caption">Manufacturers <label>(total)</label></div>
                <router-link :to="{ path: '/manufacturers', query: $route.query }"  class="link manufacturers"><span class="icon">&#x27A4;</span> Manufacturer Performance Review</router-link>
            </div>
            <div class="tile" v-if="showDealerTile">
                <div class="title dealers">Dealer Inventory & Sales</div>
                <div class="stat">{{ formatNumber(totals.dealer_count) }}</div>
                <div class="caption">Dealer locations <label>(current)</label></div>
                <router-link to="#" class="link dealers"><span class="icon">&#x27A4;</span> Dealer Inventory & Sales</router-link>
            </div>
        </div>

        <compare-dates :active="showCompare" :section="'dashboard'" @cancel="showCompare = false" />

    </section>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            loading: true,
            message: 'Loading',
            totals: {},
            reportYear: '',
            filters: {
                section: 'dashboard',
                start_date: '',
                end_date: ''
            },
            minFilterDate: '',
            maxFilterDate: '',
            showCompare: false,
            showDealerTile: false,
            showManufacturerTile: false
        }
    },
    created() {
        this.filters.start_date = this.getQueryString('start') || this.getYearStartDate()
        this.filters.end_date = this.getQueryString('end') || this.getYesterdaysDate()
        this.minFilterDate = this.filters.start_date.split('-').shift() + '-01-01'
        this.maxFilterDate = this.filters.end_date.split('-').shift() + '-12-31'
        //this.showDealerTile = this.getUser && this.getUser.user_type_code && this.getUser.user_type_code.indexOf('ADMIN') > -1
        this.showManufacturerTile = this.getUser && this.getUser.user_type_code && this.getUser.user_type_code.indexOf('ADMIN') > -1
        this.fetchData()
    },
    methods: {
		fetchData() {
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_dashboard_stats', data: this.filters }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.message = ''
                    this.totals = obj.totals
                } else {
                    this.message = obj.message
                }
            })
        },
        setFilterDates() {
            this.$router.push({ path: this.$route.path , query: { start: this.filters.start_date, end: this.filters.end_date } })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
